// components/DraggablePaper.jsx
import React, { useRef } from "react";
import { Paper } from "@mui/material";
import Draggable from "react-draggable";

export function DraggablePaper(props) {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
